export const formBodyString = (toEncode: Record<string, string>): string => {
  const formBody: string[] = [];
  for (const property in toEncode) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(toEncode[property as keyof typeof toEncode]);
    formBody.push(encodedKey + '=' + encodedValue);
  }
  const form_str = formBody.join('&');
  return form_str;
};
